import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const isDark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="relative w-14 h-8 rounded-full border border-border bg-muted flex items-center px-1 transition-colors dark:rounded-none"
    >
      <span
        className="w-6 h-6 rounded-full bg-primary text-primary-foreground grid place-items-center transition-transform duration-300 dark:rounded-none"
        style={{ transform: mounted && isDark ? "translateX(24px)" : "translateX(0)" }}
      >
        {mounted && isDark ? <Moon className="w-3.5 h-3.5" /> : <Sun className="w-3.5 h-3.5" />}
      </span>
    </button>
  );
}
